import { createSlice } from '@reduxjs/toolkit';

export const shopifyProductsSlice = createSlice({
  name: 'shopifyProducts',
  initialState: {
    shopifyProducts: [],
    loading: false,
    error: null,
    pagination: {
      current: 1,
      pageSize: 50,
      total: 0
    },
    filters: {
      searchText: '',
      selectedStatus: 'all',
      selectedShopifyStore: 'all'
    }
  },
  reducers: {
    setShopifyProducts: (state, action) => {
      state.shopifyProducts = action.payload;
    },
    setFilteredShopifyProducts: (state, action) => {
      state.shopifyProducts = action.payload;
    },
    setLoading: (state, action) => {
      state.loading = action.payload;
    },
    setError: (state, action) => {
      state.error = action.payload;
    },
    setPagination: (state, action) => {
      state.pagination = { ...state.pagination, ...action.payload };
    },
    setFilters: (state, action) => {
      state.filters = { ...state.filters, ...action.payload };
    },
  }
});

export const {
  setShopifyProducts,
  setFilteredShopifyProducts,
  setLoading,
  setError,
  setPagination,
  setFilters
} = shopifyProductsSlice.actions;

export default shopifyProductsSlice.reducer;
